export const NATIVE_APP_CODE = {
  SUCCESS: '200',
  NOT_LOGIN: '4001',
  FAIL: '9999',
};
